<template>
   <!-- <section class="boxWithBorder"> -->
    <div>
      <b-field label="Where should notifications be sent when a traveler books an option that violates a rule?"/>
        <b-field>
        <b-checkbox type="is-primary" v-model="nObj.managerViaEmail" @input="emitNotificationObject">
         Email to the traveler's manager
        </b-checkbox>
    </b-field>
    <b-field>
        <b-checkbox type="is-primary" v-model="nObj.managerViaSms" @input="emitNotificationObject">
        SMS / text message to the traveler's manager
        </b-checkbox>
    </b-field>

   <EmailAndPhoneList :email="nObj.email" :sms="nObj.sms" @remove="remove" @input="emitNotificationObject"/>
    <div class="mb-4">
      <b-button class="button is-primary " @click="addEmail=true" @input="emitNotificationObject">ADD CUSTOM EMAIL</b-button>&nbsp;&nbsp;
      <b-button class="button is-primary " @click="addPhone=true" @input="emitNotificationObject"> ADD CUSTOM MOBILE NUMBER</b-button>
    </div>

   <Email v-if="addEmail" @cancel="cancel" @saveEmail="saveEmail" @input="emitNotificationObject"/>
   <Mobile v-if="addPhone" @cancel="cancel" @savePhone="savePhone" @input="emitNotificationObject"/>
  <!-- </section> -->
  </div>

</template>
<script>

import Email from "./Email";
import Mobile from "./Mobile";
import EmailAndPhoneList from "./EmailAndPhoneList.vue";
    export default {
      name: "Notification",
      props: {
    notifications: {
      type: [Object],
    }
  
  },
      components: {
        Mobile,
        Email,
        EmailAndPhoneList
      },
      data() {
        return {
            nObj : {
                managerViaEmail : true,
                managerViaSms : false,
                email : [],
                sms : [],
            },
            addEmail : false,
            addPhone : false,
            countryCode : '+1',
        }
      },
      methods:{
        cancel(val){
            if(val=='email') {
                this.addEmail = false
            } else {
                this.addPhone = false;
            }
        },
        saveEmail(data) {
         this.nObj.email.push(data);
         this.addEmail = false;
         this.$emit('emitData',this.nObj);
        },
        savePhone(data) {
         if(data){
            this.addPhone = false;
            data = data.replace(/[^\w\s]/gi,"");
            data = this.countryCode + data;
            this.nObj.sms.push(data);
          }
          this.$emit('emitData',this.nObj);
        },
        remove(obj) {
            if(obj.val == 'email') {
               this.nObj.email.splice(obj.index,1);
            } else {
                this.nObj.sms.splice(obj.index,1);
            }
        },
        emitNotificationObject(){
          this.$emit('emitData',this.nObj);
        }
      },
      mounted() {
        this.$emit('emitData',this.nObj);

      },
      watch: {
    notifications: {
      handler(newVal, prevVal) {
        this.nObj = newVal;
      },
      deep: true,
    },
  },
    }
  </script>